<script setup lang="ts">
const props = defineProps<{
    options: { value: string; label: string }[],
    modelValue?: string[],
}>()
const toogled = computed(() => props.modelValue || [])
const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()
const onClick = (o: { value: string; label: string }) => {
    if (props.modelValue.includes(o.value)) {
        emit('update:modelValue', toogled.value.filter((v) => v !== o.value))
    } else {
        emit('update:modelValue', [...toogled.value, o.value])
    }
}
</script>

<template>
<div class="flex flex-row overflow-x-auto w-full relative">
    <span 
        v-for="o in options"
        :key="o.value"
        @click="onClick(o)"
        class="whitespace-nowrap break-keep border px-1 py-1/2 rounded-lg mr-2 cursor-pointer text-xs select-none"
        :class="{
            'border-primary-400': toogled.includes(o.value),
            'text-primary-500': toogled.includes(o.value),
            'border-secondary-400': !toogled.includes(o.value),
            'text-secondary-500': !toogled.includes(o.value),
        }">
        {{ o.label }}
    </span>
</div>
</template>